// Google Analytics (gtag.js) helpers. TMS only: the tag is loaded from the TMS
// App, not public/index.html, so the Audit app never sends anything.

const GA_MEASUREMENT_ID = "G-679DNZ68X7";

// Same as the standard Google tag snippet, injected at runtime. Safe to call twice.
export const initGoogleAnalytics = () => {
  if (typeof window === "undefined" || window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const DASHBOARD_NAMES = {
  b2b: "B2B Status Dashboard",
  b2c: "B2C Status Dashboard",
  carrier: "Carrier Dashboard",
};

export const DASHBOARD_CARD_ACTIONS = {
  viewDetails: "view_details",
  download: "download",
};

// Sends a GA event; a no-op when gtag is missing (blocked, or not loaded yet).
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch (err) {
    // Analytics must never break the UI.
  }
};

/**
 * Tracks a click on a dashboard card's "View Details" or download button.
 * @param {string} dashboardName - one of DASHBOARD_NAMES
 * @param {string} action - one of DASHBOARD_CARD_ACTIONS
 * @param {{ WidgetTitle: string, WidgetType: string, Count: number }} card
 */
export const trackDashboardCardClick = (dashboardName, action, card) => {
  const count = Number(card && card.Count);
  trackEvent("dashboard_card_click", {
    dashboard_name: dashboardName,
    card_title: card && card.WidgetTitle,
    card_widget_type: card && card.WidgetType,
    card_count: isNaN(count) ? 0 : count,
    card_action: action,
  });
};
